import { render, staticRenderFns } from "./AddNewReview.vue?vue&type=template&id=0131d567"
import script from "./AddNewReview.vue?vue&type=script&lang=js"
export * from "./AddNewReview.vue?vue&type=script&lang=js"
import style0 from "./AddNewReview.vue?vue&type=style&index=0&id=0131d567&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports